<template>
  <tr>
    <td v-for="header of tableHeader" :key="header.key"
        :class="typeof header.tdClass !== 'undefined' ? header.tdClass : ''"
        :style="header.tdStyle ? header.tdStyle : ''">
      <b-input type="number" v-model="config.pieces" v-if="header.key === 'pieces'"/>

      <app-select
        v-model="config.articleId"
        allow-text-value
        :text-value="config.article"
        @changeText="text => config.article = text"
        text-value-placeholder="Artikel angeben"
        :options="articleOptions"
        v-else-if="['category', 'name'].includes(header.key)"
      ></app-select>

      <app-select
        v-model="config[header.key]"
        text-value-placeholder="Land angeben"
        :options="countryOptions"
        v-else-if="['nativityId', 'nativityIdSty'].includes(header.key)"
        @input="onNativityChange"
      ></app-select>

      <app-select
        v-model="config[header.key]"
        text-value-placeholder="Bundesland angeben"
        :options="sortedStates"
        v-else-if="['stateId'].includes(header.key)"
        :disabled="stateIdDisabled"
      ></app-select>
      <app-select
        v-model="config[header.key]"
        text-value-placeholder="Bundesland angeben"
        :options="sortedStates"
        v-else-if="['stateIdSty'].includes(header.key)"
        :disabled="stateIdStyDisabled"
      ></app-select>

      <span v-else-if="['country'].includes(header.key)">AT</span>

      <b-input type="number" step=".01" v-model="config.weight" style="text-align: center" v-else-if="header.key === 'weight'"/>

      <div v-else-if="header.key === 'actions'">
        <b-button variant="danger" icon="save" size="sm" title="Löschen" @click="emit('onRemove', config)">
          <font-awesome-icon icon="times"/>
        </b-button>
      </div>

      <b-input type="text" v-model="config[header.key]" v-else-if="!['actions'].includes(header.key)"/>
    </td>
  </tr>
</template>

<script>
import SelectPigSty from "@/components/select-pig-sty/select-pig-sty.vue";
import {computed, ref, watch, onMounted} from "@vue/composition-api";
import AppSelect from "@/app/components/general/AppSelect.vue";

export default {
  components: {AppSelect, SelectPigSty},
  props: {
    context: {
      type: String,
      required: true,
    },
    tableHeader: {
      type: Array,
      required: true,
    },
    seller: {
      type: Object,
      default: () => {}
    },
    value: {
      type: Object,
      default: undefined
    },
    showAdd: {
      type: Boolean,
      default: false
    }
  },
  emits: ['add'],

  setup(props, { emit }) {
    const store = window.useStore()
    const config = ref(props.value);

    config.value.lfbisSty = props.seller.lfbis;

    const articleOptions = computed(() => {
      const articles = typeof store.state.pwa.deliveries[props.context] !== 'undefined' ? store.state.pwa.deliveries[props.context].config.article.data : []

      return articles.map(a => {
        let text = a.name
        if (typeof a.description !== 'undefined' && a.description) {
          text += ` - ${a.description}`
        }

        const values = {
          value: a.name !== 'Anderes...' ? (a.id ? a.id : (a.id ? a.name : a.description)) : '--text--',
          text,
        }
        console.log("values", values);
        return values;
      })
    })

    const countryOptions = computed(() => {
      const countries = typeof store.state.pwa.deliveries["piglet"] !== 'undefined' ? store.state.pwa.deliveries["piglet"].config.countries.data : []

      return countries.map(c => {
        let text = c.iso

        return {
          value: c.name !== 'Anderes...' ? c.iso : '--text--',
          text,
        }
      })
    })

    const stateOptions = computed(() => {
      const states = typeof store.state.pwa.deliveries["piglet"] !== 'undefined' ? store.state.pwa.deliveries["piglet"].config.states.data : []

      return states.sort(function (a, b) {
        if (a.amaId < b.amaId) {
          return -1;
        }
        if (a.amaId > b.amaId) {
          return 1;
        }
        return 0;
      }).map(c => {
        let text = c.amaId

        return {
          value: c.name !== 'Anderes...' ? c.amaId : '--text--',
          text,
        }
      })
    })
    const states = typeof store.state.pwa.deliveries["piglet"] !== 'undefined' ? store.state.pwa.deliveries["piglet"].config.states.data : []

    const sortedStates = ref(states.sort(function (a, b) {
      if (a.amaId < b.amaId) {
        return -1;
      }
      if (a.amaId > b.amaId) {
        return 1;
      }
      return 0;
    }).map(c => {
      let text = c.amaId

      return {
        value: c.name !== 'Anderes...' ? c.amaId : '--text--',
        text,
      }
    }));

    watch(articleOptions, () => {
      if (articleOptions.value && !config.value.articleId) {
        config.value.articleId = articleOptions.value[0].value
      }
    }, { immediate: true })

    const configToSend = computed(() => {
      return ({
        ...config.value,
        // articleId: props.context === 'pigSty' ? null : config.value.articleId,
        // article: props.context === 'pigSty' && !config.value.article ? config.value.articleId : config.value.article,
        // text: props.context === 'pigSty' && !config.value.article ? config.value.articleId : config.value.article,
      })
    })

    const producers = computed(() => {
      if (!store.state.pwa.pigSty.data.length) {
        return []
      }
      return store.state.pwa.pigSty.data.reduce((res, item) => {
        res.push(item)
        return res
      }, [])
    })

    const buildName = (article) => {
      return `${ article.number ? `${article.number} - ` : '' }` + article.name
    }

    // const valid = computed(() => {
    //   return config.value.pieces > 0 &&
    //     config.value.weight > 0 &&
    //     !!config.value.nativityId
    // })


    const stateIdDisabled = ref(false);
    const stateIdStyDisabled = ref(false);

    const onNativityChange = () => {
      if(config.value["nativityId"] !== "AT") {
        stateIdDisabled.value = true;
        config.value["stateId"] = null;
      }
      else {
        stateIdDisabled.value = false;
        config.value["stateId"] = '6';
      }

      if(config.value["nativityIdSty"] !== "AT") {
        stateIdStyDisabled.value = true;
        config.value["stateIdSty"] = null;
      }
      else {
        stateIdStyDisabled.value = false;
        config.value["stateIdSty"] = '6';
      }
    }
    watch(() => props.seller, () => {
      config.value.lfbisSty = props.seller.lfbis;
    }, {deep: true})

    watch(() => config, () => {
      if(!loaded) return;
      console.log("Config chagne", config);
      config.value.pieces = Number(config.value.pieces);
      console.log("configToSend", configToSend);
      emit('onChange', configToSend.value);
    }, {deep:true});


    const loaded = ref(false);
    onMounted(() => {
      loaded.value = true;
    });
    return {
      articleOptions,
      countryOptions,
      stateOptions,
      stateIdDisabled,
      stateIdStyDisabled,
      producers,
      config,
      configToSend,
      onNativityChange,
      buildName,
      // valid,
      loaded,
      emit,
      sortedStates,
    }
  }
}
</script>

<style lang="scss">
ul.article-item-list {
  list-style-type: none;
  margin: 0;
  padding: 0;

  li {
    a {
      text-decoration: none;
      color: #383838;
      margin: 7px 0;
      display: block;
      background: #efefef;
      padding: 10px 16px;
      border-radius: 10px;
    }

    span {
      display: block;

      &.name {
        font-weight: bold;
      }
    }
  }
}
</style>
